import React from 'react';
import { VariableModel } from '../../iasConfigSchema';

type Props = {
  variable: VariableModel;
};

const UnknownVariableWidget: React.FC<Props> = ({ variable }) => {
  return (
    <div style={{ background: 'red' }}>
      No component found to render variable type '{variable.type}', param: '
      {variable.name}'.
    </div>
  );
};

export default UnknownVariableWidget;
